/**
 * @flow
 * @relayHash 0565e1ab294fed89d5ed80577587b39a
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type HomeMainSliderQueryVariables = {||};
export type HomeMainSliderQueryResponse = {|
  +slides: $ReadOnlyArray<?{|
    +button_color: string,
    +button_text: string,
    +button_text_color: string,
    +featured_shop: ?boolean,
    +id: string,
    +large_photo_object: ?{|
      +url_original: ?string
    |},
    +ref_id: string,
    +sub_title_1: string,
    +sub_title_1_color: string,
    +sub_title_2: string,
    +sub_title_2_color: string,
    +title: string,
    +title_color: string,
    +url: string,
  |}>
|};
export type HomeMainSliderQuery = {|
  variables: HomeMainSliderQueryVariables,
  response: HomeMainSliderQueryResponse,
|};
*/


/*
query HomeMainSliderQuery {
  slides {
    button_color
    button_text
    button_text_color
    featured_shop
    id
    large_photo_object {
      url_original
    }
    ref_id
    sub_title_1
    sub_title_1_color
    sub_title_2
    sub_title_2_color
    title
    title_color
    url
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "slides",
    "storageKey": null,
    "args": null,
    "concreteType": "Slider",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "sub_title_1",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "button_color",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "button_text_color",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "featured_shop",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "large_photo_object",
        "storageKey": null,
        "args": null,
        "concreteType": "ImageDetails",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "url_original",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "ref_id",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "button_text",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "sub_title_1_color",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "sub_title_2",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "sub_title_2_color",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "title",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "title_color",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "url",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "HomeMainSliderQuery",
  "id": null,
  "text": "query HomeMainSliderQuery {\n  slides {\n    button_color\n    button_text\n    button_text_color\n    featured_shop\n    id\n    large_photo_object {\n      url_original\n    }\n    ref_id\n    sub_title_1\n    sub_title_1_color\n    sub_title_2\n    sub_title_2_color\n    title\n    title_color\n    url\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "HomeMainSliderQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": v0
  },
  "operation": {
    "kind": "Operation",
    "name": "HomeMainSliderQuery",
    "argumentDefinitions": [],
    "selections": v0
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '5fc3206221fb22a597943af79a0ab94a';
module.exports = node;
